import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from 'antd';
import { useSessionAppointment } from '@hooks/useSessionAppointment';
import { useSessionFormState } from '@hooks/useSessionFormState';
import { useQuery } from '@tanstack/react-query';
import * as actions from '@actions';
import { useDispatch } from 'react-redux';
import { SessionFormItem } from './SessionFormItem';

export const LetterTypesFormItem = () => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const { appointment } = useSessionAppointment();

  const [letterReq, setLetterReq] = useSessionFormState('letterReq');

  const { data: letterTypes } = useQuery({
    queryKey: ['getLetterCodes', appointment.appointment_id],
    queryFn: () => dispatch(actions.getLetterCodes(appointment.appointment_id)),
    select: (data) => data?.letter_types,
    enabled: !!appointment.appointment_id
  });

  if (!letterTypes || letterTypes.length === 0 || !letterReq) return null;

  const defaultLetter = letterTypes.find((letter) => letter.letter_code === letterReq?.letter_code) || letterTypes[0];

  return (
    <SessionFormItem name="Letter Template to use" label={t('Letter Template to use')} linkAria>
      <Select
        disabled={appointment?.appointment_completed || letterTypes?.length === 1}
        placeholder={t('Select Template')}
        defaultValue={defaultLetter?.letter_code}
        onChange={(value: string) => {
          setLetterReq({
            letter_code: value,
            letter_template_type: value === 'IMG_REQ' ? 'Investigation' : ''
          });
        }}
        data-testid="letter-template-select"
        options={letterTypes?.map((item) => ({
          label: item.description,
          value: item.letter_code
        }))}
      />
    </SessionFormItem>
  );
};
